var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95956 17.7077C9.21695 18.6862 11.7862 18.2494 13.6106 16.688C13.4984 16.5342 13.3938 16.372 13.2979 16.2015C12.1268 14.1192 12.1632 12.1012 12.4838 10.642C12.643 9.91732 12.8732 9.32131 13.0655 8.90222C13.1621 8.69161 13.2507 8.52252 13.3185 8.40071L13.8535 7.55097L15.3913 7.52596C15.729 7.55494 16.1614 7.61477 16.6483 7.7361C16.3706 4.35958 14.8569 2.0061 14.8569 2.0061C14.8569 2.0061 7.63979 1.56139 3.86747 8.26877C2.21858 11.2006 2.99572 14.8868 5.55945 16.8779L3.37883 20.7551C3.15561 21.152 3.28808 21.6595 3.67471 21.8887C4.06134 22.1178 4.55572 21.9818 4.77894 21.5849L6.95956 17.7077ZM6.95956 17.7077C6.71372 17.6011 6.47157 17.4778 6.23449 17.3372C5.99741 17.1967 5.77228 17.0431 5.55945 16.8779L7.69005 13.0896C7.91327 12.6927 8.40765 12.5567 8.79428 12.7858C9.18091 13.015 9.31338 13.5225 9.09016 13.9194L6.95956 17.7077Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3101 16.9706C16.9033 17.4109 15.3364 16.8172 14.5696 15.4537C12.6834 12.1 14.6753 9.00305 14.6753 9.00305C14.6753 9.00305 18.2839 8.7807 20.17 12.1344C20.9369 13.498 20.6542 15.1879 19.5793 16.2184L20.9022 18.5706C21.1042 18.9297 20.9832 19.3882 20.632 19.5947C20.2809 19.8012 19.8325 19.6775 19.6305 19.3184L18.3101 16.9706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.3b99c296fe4cfa94db355043d4e2580d.svg";
export { ForwardRef as ReactComponent };